<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li
      *ngFor="let crumb of crumbs; let i = index"
      class="breadcrumb-item"
      [class.active]="i === crumbs.length - 1"
    >
      <a
        *ngIf="(i !== crumbs.length - 1) && crumb.path == 'https://www.scalanthropy.com/'"
        [href]="crumb.path"
        class="link-secondary text-decoration-none"
        target="_blank"
      >
        <i *ngIf="!!crumb.iconClass" [class]="['bi', crumb.iconClass]"></i>
        <span *ngIf="!!crumb.label"> {{ crumb.label }}</span>
      </a>
      <a
        *ngIf="(i !== crumbs.length - 1) && crumb.path != 'https://www.scalanthropy.com/'"
        [href]="crumb.path"
        class="link-secondary text-decoration-none"
      >
        <i *ngIf="!!crumb.iconClass" [class]="['bi', crumb.iconClass]"></i>
        <span *ngIf="!!crumb.label"> {{ crumb.label }}</span>
      </a>
      <span *ngIf="i === crumbs.length - 1" class="active">
        <i *ngIf="!!crumb.iconClass" [class]="['bi', crumb.iconClass]"></i>
        <span *ngIf="!!crumb.label"> {{ crumb.label }} </span>
      </span>
    </li>
  </ol>
</nav>
